import _ from 'lodash'
import { all, call, put, select, takeLatest } from 'redux-saga/effects'

import { API_LANGUAGE_MAPPING } from '../../../../global/i18n/constants'
import { localeSelector } from '../../../../global/i18n/selectors'

import { callApiAsync } from 'services/api/callAPIAsync'

import { setErrorMessage } from 'components/Windows/CentralMessagesList/reducer'
import { transformMovieSeating } from './helpers'
import { loadData, setData, setLoading, setOriginalSeating } from './reducer'

export function* updateSeating() {
    const language = API_LANGUAGE_MAPPING?.[yield select(localeSelector)]
    const eventid = localStorage.getItem('eventid')

    const { data, error } = yield call(callApiAsync, 'getHallData', { eventid, language })

    if (error) {
        yield setErrorMessage(error)
        console.error(error)
        return
    }

    const transformedSeating = transformMovieSeating(data)

    // Transformed seating is only used to render seats in hall - mainly group seats
    yield put(setData(transformedSeating))

    // Original seating data is used for everything else - selecting seats, etc.
    yield put(setOriginalSeating(data?.seats))
}

function* seatingLoadDataCallSaga(action) {
    const language = API_LANGUAGE_MAPPING?.[yield select(localeSelector)]
    const eventid = action?.payload?.eventId

    if (_.isNil(eventid) || _.isNil(language)) return null

    yield put(setLoading(true))

    //const seating = yield call(getSeatingArrangement, { eventid, language })

    const { data, error } = yield call(callApiAsync, 'getHallData', { eventid, language })

    if (error) {
        yield setErrorMessage(error)
        yield put(setLoading(false))
        return
    }

    const transformedSeating = transformMovieSeating(data)

    // Transformed seating is only used to render seats in hall - mainly group seats
    yield put(setData(transformedSeating))

    // Original seating data is used for everything else - selecting seats, etc.
    yield put(setOriginalSeating(data?.seats))

    yield put(setLoading(false))
}

export default function* hallSeatingSaga() {
    yield all([takeLatest(loadData.type, seatingLoadDataCallSaga)])
}
